import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const HeadingRow = styled.div`
  padding: 10px 16px;
  background-color: #efefef;
  border-radius: 4px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  margin-bottom: 4px;

  &.with-top-margin {
    margin-top: 24px;
  }

  ${media.xs`
    padding: 10px 16px;
  `}
`;

export const TitleText = styled.div`
  font-weight: 600;
`;

export const OptionsSelectedText = styled.div`
  font-weight: 300;
`;

export const ConfigurationGroupWrapper = styled.div`
  margin-top: 20px;
`;
